import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import type { WithRouter } from '../../typings/custom';
import Head from '../../components/Head/Head';
import { Layout } from '../../components/Layout/Layout';
import SignIn from '../../components/SignIn/SignIn';
import { serverSideProps } from '../../lib/serverSideProps';

const SignInPage = ({
  router,
}: InferGetServerSidePropsType<typeof getServerSideProps> & WithRouter) => (
  <>
    <Head pathname={router && router.route} />
    <Layout>
      <SignIn />
    </Layout>
  </>
);

export const getServerSideProps = (async (context) => {
  return serverSideProps({
    context,
    namespaces: ['common', 'osc-footer', 'osc-header', 'osc-link', 'osc-login'],
  });
}) satisfies GetServerSideProps;

export default SignInPage;
